import { Step } from '../model/checkoutModel';
import { checkoutSteps } from './checkoutSteps';

export const getIsCheckoutStep = (value?: string): value is Step => checkoutSteps.includes(value as never);
